import { Link } from 'react-router-dom';

const quotes = [
  {
    text: 'I published the dealer slang dictionary. I explain how rate markup works. I tell you what GAP insurance actually costs. Does that hurt my profit? Yes. Is it worth it? Also yes.',
    topic: 'On Transparency',
  },
  {
    text: 'A broker works for you, not the dealership. That\'s the entire point. I don\'t make money by marking up your interest rate. I get paid to find you the right car at the right price.',
    topic: 'On the Broker Model',
  },
  {
    text: 'I can look at myself in the mirror. The customers who find me through honest pricing — those are the customers I want to work with anyway.',
    topic: 'On Why This Exists',
  },
];

export default function OwnerPhilosophyQuote() {
  return (
    <section className="py-16 bg-[#FAFAF8] border-t border-slate-100">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-10">
          <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#1A2332] flex-shrink-0">
            <i className="ri-double-quotes-l text-[#E8B84B] text-xl" />
          </div>
          <div>
            <p className="text-[10px] font-bold uppercase tracking-widest text-[#E8B84B] mb-0.5">
              The Philosophy Behind the Process
            </p>
            <h2 className="text-xl sm:text-2xl font-black text-[#1A2332]" style={{ fontFamily: 'Oswald, sans-serif' }}>
              Why This Works the Way It Does
            </h2>
          </div>
          <Link
            to="/about-the-owner"
            className="sm:ml-auto inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-xs font-bold whitespace-nowrap cursor-pointer transition-all bg-[#1A2332] text-[#E8B84B] hover:bg-[#243044]"
          >
            The Guy Behind the Madness
            <i className="ri-arrow-right-line text-xs" />
          </Link>
        </div>

        {/* Quote Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
          {quotes.map((q) => (
            <div
              key={q.topic}
              className="relative bg-white border border-slate-200 rounded-xl p-6 shadow-sm hover:shadow-md hover:border-[#E8B84B]/40 transition-all"
            >
              {/* Decorative quote mark */}
              <div className="absolute top-4 right-5 text-5xl font-serif text-[#E8B84B]/15 leading-none select-none pointer-events-none">
                &ldquo;
              </div>
              <p className="text-[10px] font-bold uppercase tracking-widest text-[#E8B84B] mb-3">
                {q.topic}
              </p>
              <p className="text-slate-700 text-sm leading-relaxed italic">
                &ldquo;{q.text}&rdquo;
              </p>
              <div className="mt-4 pt-4 border-t border-slate-100 flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center rounded-full bg-[#1A2332]">
                  <i className="ri-user-line text-[#E8B84B] text-[10px]" />
                </div>
                <span className="text-xs text-slate-400 font-medium">Owner, Rockhound Auto</span>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom callout */}
        <div className="bg-[#1A2332] rounded-xl px-6 py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="flex-1">
            <p className="text-white/90 text-sm leading-relaxed">
              <span className="text-[#E8B84B] font-bold">This isn't a brand voice.</span>
              {' '}It's just how this business actually runs — built by someone who got tired of watching people get taken advantage of at dealerships.
            </p>
          </div>
          <div className="flex flex-wrap gap-2 flex-shrink-0">
            <Link
              to="/about-the-owner"
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-xs font-bold whitespace-nowrap cursor-pointer transition-all bg-[#E8B84B] text-[#1A2332] hover:bg-[#d4a43a]"
            >
              <i className="ri-user-line text-xs" />
              Read the Full Story
            </Link>
            <Link
              to="/why-the-dogs"
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-xs font-bold whitespace-nowrap cursor-pointer transition-all bg-white/10 border border-white/20 text-white hover:bg-white/20"
            >
              <i className="ri-heart-line text-xs" />
              Why the Dogs
            </Link>
          </div>
        </div>

      </div>
    </section>
  );
}
